export default String.raw`
.contact-container {
    &__details {
        width: 100%;
    }

    &__form {
        width: 100%;
    }
}
`